export default __webpack_public_path__ + "static/one-to-100-2e1d7bfeb430051bd71e452642fcfdd2.png";